import { PrintModel } from '@app/src/views/StepTwo/channelPublication/models/print';
import { PrintPostDTO } from '@app/src/views/StepTwo/channelPublication/dto/PrintDTO';
import { PublicationModel } from '@app/src/views/StepTwo/channelPublication/models/typePublication';

export const hydrateData = (data: PrintModel) => {
  let arrPrints = [];
  const sectionId = data.general.section;
  const employmentId = data.general.employment;
  const propertyId = data.general.property;
  const typeVehicleId = data.general.typeVehicle;
  const brandAdecsysId = data.general.brandAdecsys;
  const modelAdecsysId = data.general.modelAdecsys;
  let newData = {};

  newData['print'] = {
    title: data.general.title,
    description: quitLastSpace(data.general.description),
    operation_id: data.general.operation
  };
  if (sectionId) {
    newData['print']['section_id'] = sectionId;
  }
  if (employmentId) {
    newData['print']['employment_id'] = employmentId;
  }
  if (propertyId) {
    newData['print']['property_id'] = propertyId;
  }
  if (typeVehicleId) {
    newData['print']['vehicle_type_id'] = typeVehicleId;
    newData['print']['brand_adecsys'] = brandAdecsysId || 0;
    newData['print']['model_adecsys'] = modelAdecsysId || 0;
  }
  Object.keys(data.printsByChannel).forEach((key) => {
    arrPrints = [ ...arrPrints, ...data.printsByChannel[key]]
  })
  newData['details'] = arrPrints.map((detail: PublicationModel) => ({
    publication_id: detail.publicationId,
    package_id: detail.packageId,
    date_print: detail.datePrint
  }));
  let extrachargeData = getExtrachargeSelecteds(data.extracharges, data.photoVignette);
  newData['extracharges'] = extrachargeData;
  newData['token'] = data.token;
  return newData as PrintPostDTO;
};

const getExtrachargeSelecteds = (extracharge, dataPhotoVignette) => {
  let selecteds = [];
  if (extracharge && Object.keys(extracharge).length > 0) {
    Object.keys(extracharge).map((id) => {
      let currentArr = extracharge[id] && extracharge[id].data && extracharge[id].data.length > 0 && extracharge[id].data.filter(item => item.checked === true).map((item) => {
        if (item.input === 'photoVignette') {
          return({
            publication_id: Number(id),
            extracharge_id: Number(item.value),
            photo_name: dataPhotoVignette[id].fileName
          })
        }
        if (item.input === 'vignette') {
          return({
            publication_id: Number(id),
            extracharge_id: Number(item.value),
            code_label: extracharge[id].vignette && extracharge[id].vignette.codeLabel || '',
            label_name: extracharge[id].vignette && extracharge[id].vignette.name || 'ninguno',
            photo_name: dataPhotoVignette[id] && dataPhotoVignette[id].fileName
          })
        }
        return({
            publication_id: Number(id),
            extracharge_id: Number(item.value)
          })
        }
      );
      if (currentArr && currentArr.length > 0) {
        selecteds = [ ...selecteds, ...currentArr];
      }
    })
  }
  return selecteds;
};

const quitLastSpace = (text) => {
  let arrText = text.split(' ');
  if (arrText[arrText.length - 1].length === 0) {
    arrText.pop();
  }
  return arrText.join(' ');
};
